import type { Enum, Matchday, MatchStatus, Round, Team } from '@uefadigital/panenka';

import type { Order } from '@shared-types/common.types';
import type { Draw } from '@shared-types/draw.types';
import type { RoundPhase } from '@shared-types/match.types';

export const MatchesCalendarMode = {
  DATES: 'DATES',
  ROUNDS: 'ROUNDS',
  BRACKET: 'BRACKET',
} as const;
export type MatchesCalendarMode = Enum<typeof MatchesCalendarMode>;

export const MatchesCalendarData = {
  MATCHES: 'MATCHES',
  DRAWS: 'DRAWS',
  FRIENDLIES: 'FRIENDLIES',
} as const;
export type MatchesCalendarData = Enum<typeof MatchesCalendarData>;

export type MatchesCalendarTab = {
  id: string;
  type: MatchesCalendarTabType;
  date: string | null;
  round?: Round;
  matchdays?: Matchday[];
  draw?: Draw;
  numberOfMatches?: number;
  additionalMatches?: number;
  oneTeamPerSlot?: boolean;
};

export const MatchesCalendarTabType = {
  DATE: 'd',
  ROUND: 'rd',
  MATCHDAY: 'md',
  DRAW: 'dw',
} as const;
export type MatchesCalendarTabType = Enum<typeof MatchesCalendarTabType>;

export type ProvisionalMatchType = {
  id?: string;
  status: MatchStatus;
  round: Round;
  matchday: Matchday;
  kickOffTime: { date: string };
  homeTeam: Team[];
  awayTeam: Team[];
};

export type MatchesCalendarOptions = {
  cssClass: string;
  title: string;
  competitionId: string;
  selectedTeamId: string;
  seasonYear: string;
  phase: RoundPhase | 'ALL';
  sort: Order;
  includeFriendlies: boolean;
  maxColumns: number;
  stickyHeader: boolean;
  showAllMatches: boolean;
  enableTabsMenu: boolean;
  useBracketView: boolean;
  useNewBracket: boolean;
  bracketDisclaimerTagSingleTeam?: string;
  bracketDisclaimerTag?: string;
  bracketDisclaimerTooltipTag?: string;
  bracketDisclaimerUrl?: string;
  disableRouting: boolean;
  disclaimerText: string;
  enableAddToCalendar: boolean;
  calendarServiceApiUrl: string;
  filterByTeam: boolean;
  usePhaseTabs: boolean;
  isDomestic: boolean;
  promoSlotIncluder: string;
  showHighlights: boolean;
  disableTeamsLink: boolean;
  hideDate: boolean;
  hideRound: boolean;
  hideContext: boolean;
  hideSeeMore: boolean;
  showNoMatchesBox: boolean;
  compFormatUrl: string;
  isPromoEnabled: boolean;
  promoCssClass: string;
  bottomPanelSelector: string;
  promoOpeningTime: number;
  disablePromoPopover: boolean;
  headerTheme: string;
  hideMatchday: boolean;
  showPromoHighlights: boolean;
  highlightsBottomPanelSelector: string;
  showPredictorPromo: boolean;
  enableSponsorHeader: boolean;
  enableTitleTeamPage: boolean;
  showSimulatorPromotion?: boolean;
  useBracketPaths?: boolean;
  bracketLowerPartText?: string;
  bracketUpperPartText?: string;
  showFakeMatchRoundDate: boolean;
  showProvisionalMatches?: boolean;
  useGroupingMatchesMiniTournaments?: boolean;
};
